<template>
  <Dialog :visible.sync="drawer" custom-class="dialogBg" width="1200px" :modal="true" :modal-append-to-body="false">
    <div class="el-dialog__title flex" slot="title">{{ clsOpts.school }} - {{ clsOpts.gradeTxt }} - 榜单数据 <div
        class="crTxt line1" v-if="!urlOpts.isWall">本班已布置练习 <span class="mColor">{{ homeWorkTotal }}</span> 次</div>
    </div>
    <Form :model="urlOpts" :inline="true" ref="ruleForm">
      <FormItem label="榜单类型">
        <Select v-model="urlOpts.isWall" placeholder="榜单类型" @change="onWeek">
          <Option label="学生练习统计榜" :value="0"></Option>
          <Option label="学生练习上墙统计榜" :value="1"></Option>
        </Select>
      </FormItem>
      <FormItem label="统计周期" v-show="urlOpts.type === 1">
        <Select v-model="urlOpts.weekType" placeholder="统计周期" @change="onSelect">
          <Option label="周榜" :value="0"></Option>
          <Option label="总榜" :value="1"></Option>
          <Option label="自定义周期" :value="2"></Option>
        </Select>
      </FormItem>
      <FormItem v-show="urlOpts.type === 1 && urlOpts.weekType !== 1">
        <DatePicker class="dateBox" v-model="urlOpts.date" popper-class="popperCls" prefix-icon=" " format="yyyy-MM-dd" 
          type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" style="width: 240px;" :clearable="false" :editable="false"
          :disabled="!urlOpts.weekType"></DatePicker>
      </FormItem>
      <FormItem class="flex" style="float: right;">
        <el-button type="success" class="formBtn" size="medium" @click="loadRank">搜索</el-button>
        <el-button class="formBtn" size="medium" @click="onReset">重置</el-button>
      </FormItem>
    </Form>

    <div class="crTabs flex">
      <div class="crTab flex-center" :class="urlOpts.type === idx + 1 && 'on'" v-for="(item, idx) in tabs" :key="item"
        @click="changeType(idx + 1)">{{ item }}</div>
    </div>

    <div class="rWrap">
      <div class="sTable flex">
        <div class="rsTable">
          <div class="rList flex-center rHead">
            <div class="rItem">序号</div>
            <div class="rItem" v-for="(menu, key) of menus" :key="key">{{ menu }}</div>
          </div>
          <div class="rMain" :class="isEmpty && 'flex-center'">
            <Empty v-show="isEmpty" />
            <div class="rList flex-center" v-for="(item, idx) in rankList" :key="idx + urlOpts.type">
              <div class="rItem">{{ idx + 1 }}</div>
              <div class="rItem" v-for="(menu, key) of menus" :key="key">
                {{
                  item[key] ||
                  (["avgScore", "maxScore"].includes(key) ? "-" : 0)
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Dialog>
</template>

<script>
import {
  Dialog,
  Form,
  FormItem,
  Select,
  Option,
  Input,
  Button,
  DatePicker
} from "element-ui";
import util from 'libs/util'
import utils from '@/utils'
import Empty from "business/Empty";

export default {
  data() {
    return {
      drawer: false,
      isEmpty: false,
      tabs: Object.freeze(["单次练习", "周期练习"]),
      urlOpts: {},
      clsOpts: {},
      rankList: [],
      homeWorkTotal: 0,
    }
  },
  computed: {
    menus() {
      return +this.urlOpts.isWall ? {
        name: "学生",
        count: "上墙次数",
      } : this.urlOpts.type === 1
        ? {
          name: "学生",
          workTotal: "完成练习数",
          percentage: "完成率",
          avgScore: "平均分",
          maxScore: "最高分",
        }
        : {
          name: "学生",
          workTotal: "完成次数",
          dayCount: "完成天数",
          avgScore: "平均分",
          maxScore: "最高分",
        };
    }
  },
  components: {
    Empty,
    Dialog,
    Form,
    FormItem,
    Select,
    Option,
    Input,
    DatePicker,
    ElButton: Button,
  },
  methods: {
    onReset() {
      this.urlOpts = {
        ...this.urlOpts,
        isWall: 0,
        weekType: 0,
        date: null,
      }
      this.changeType(this.urlOpts.type)
    },
    onWeek() {
      this.urlOpts.weekType = 0;
      // if(this.urlOpts.type === 1)
      this.onSelect(0)
      this.changeType(this.urlOpts.type);
    },
    onSelect(idx) {
      let beginTime = null;
      let endTime = null;
      if (idx === 1) return this.urlOpts.date = null;
      if (!idx) {
        const { monday, sunday } = utils.getWeekRange();
        beginTime = monday;
        endTime = sunday;
      } else if (+idx === 2) {
        const { startDay, endDay } = utils.getMonthStartDates();
        beginTime = startDay;
        endTime = endDay;
      }
      this.urlOpts.date = [beginTime, endTime]
    },
    changeType(type) {
      this.urlOpts.type = type;
      if (type === 1) {
        this.onSelect(this.urlOpts.weekType);
      } else {
        this.urlOpts.date = null;
      }
      this.loadRank();
    },
    openRank(opts) {
      this.urlOpts = {
        isWall: 0,
        weekType: 0,
        type: 1,
        date: null,
        classesId: opts.classesId
      };
      this.isEmpty = false;
      this.clsOpts = opts;
      this.onSelect(0);
      this.loadRank();
      this.drawer = true;
    },
    async loadRank() {
      try {

        this.rankList = [];
        const { isWall, date } = this.urlOpts;
        const dateObj = date ? {
          beginTime: util.date.format(date[0], 'yyyy-MM-dd'),
          endTime: util.date.format(date[1], 'yyyy-MM-dd'),
        } : {}
        const res = await this.$post(+isWall ? '/classes/studentUpWallRank.json' : '/classes/studentHomeWorkList.json', {
          ...this.urlOpts,
          ...dateObj,
          // classesId: "1170"
        })
        if (isWall) {
          this.rankList = res.data || [];
        } else {
          const info = res.data || {};
          this.rankList = info.list || [];
          this.homeWorkTotal = info.homeWorkTotal || 0;
        }
        console.log('-------------')
        this.isEmpty = !this.rankList.length;
      } catch (error) {
        console.log(error)
        this.rankList = []
        this.isEmpty = true;
      }
    }
  }
}
</script>

<style lang="less" scoped>
/deep/.dialogBg .el-dialog__body {
  padding: 30px 40px 0;
}

.crTxt {
  font-size: 14px;
  color: #666666;
  margin-left: 32px;
  font-weight: normal;
}

.crTabs {
  padding-top: 24px;
  border-top: 1px solid #ddd;

  .crTab {
    font-size: 14px;
    color: #666666;
    margin-right: 40px;
    cursor: pointer;

    &.on {
      font-size: 16px;
      color: #FB7C33;
      font-weight: bold;
      position: relative;

      &::after {
        content: '';
        display: inline-block;
        width: 18px;
        height: 4px;
        background: #FB7C33;
        border-radius: 2px;
        position: absolute;
        bottom: -8px;
        left: 50%;
        transform: translateX(-50%);
      }
    }
  }
}

.rWrap {
  padding-top: 30px;

  // .sTable {
  //   padding-left: 15px;
  //   padding-right: 10px;
  // }

  .rsTable {
    flex: 1;
    overflow: auto;

    .rMain {
      max-height: 54vh;
      min-height: 36vh;
      overflow-y: auto;
      background: #FFFFFF;
    }

    .rList {
      &:nth-child(2n + 1) {
        background-color: #F6FEFF;
      }

      &.rHead {
        padding: 5px 0;
        font-size: 16px;
        color: #666666;
        background: rgba(255, 255, 255, 0.8);
      }

      &:not(.rHead) {
        padding: 22px 0;
        font-weight: bold;
        color: #333333;
      }

      .rItem {
        flex: 1;
        text-align: center;
      }
    }
  }
}
</style>
